import { AgentComponentMode } from '@reach/shared-types/agent-components';
import { useId } from 'react';
import type { ComponentDraft } from './component-draft';
import { TENANT_PREVIEW_COPY } from './component-page-copy';
import { TenantControl } from './TenantControl';
import styles from './TenantPreviewCard.module.css';

interface TenantPreviewCardProps {
  draft: ComponentDraft;
}

/** How the component appears to tenants in onboarding and settings, as the draft stands. */
export const TenantPreviewCard = ({ draft }: TenantPreviewCardProps) => {
  const headingId = useId();
  const componentIsHidden = draft.mode === AgentComponentMode.HIDDEN;
  const previewName = draft.tenantName || draft.name;

  return (
    <section className={styles.preview} aria-labelledby={headingId}>
      <h2 id={headingId}>{TENANT_PREVIEW_COPY.heading}</h2>
      <p>{TENANT_PREVIEW_COPY.description}</p>
      {componentIsHidden ? (
        <p className={styles.hidden}>{TENANT_PREVIEW_COPY.hidden}</p>
      ) : (
        <article className={styles.tenantView}>
          <h3>{previewName}</h3>
          {draft.tenantDescription && <p>{draft.tenantDescription}</p>}
          <TenantControl mode={draft.mode} />
        </article>
      )}
    </section>
  );
};
